import React from 'react';
export const spinnerSize = {
    small: 26,
    medium: 32,
    large: 40
};
